module.exports = __webpack_public_path__ + "static/media/driver.1e7598d7.png";